import React, {useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import axios from 'axios';
import '../globales';
import {Redirect} from 'react-router-dom/cjs/react-router-dom.min';
import Iframe from 'react-iframe';
import GLOBAL from "../globales";
import WarningIcon from "@material-ui/icons/Warning";
import {DialogContentText} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function Registrar() {
    const classes = useStyles();

    const [success, setSuccess] = useState(false);
    const [open, setOpen] = useState(false);

    const [dialog, setDialog] = React.useState({
        open: false, text: ''
    });

    const handleDialogOpen = text => setDialog({open: true, text: text});
    const handleDialogClose = () => setDialog({...dialog, open: false});

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const urlQuery = '?user_action=terminos_condiciones&user_email=1&user_token=1';

    const [data, setData] = React.useState({
        email: '',
        nombre: '',
        apaterno: '',
        amaterno: '',
        password: '',
        confirm_password: '',
    });

    const handleEmailChange = (val) => {
        setData({
            ...data,
            email: val
        });
    }
    const handleNombreChange = (val) => {
        setData({
            ...data,
            nombre: val
        });
    }
    const handleApaternoChange = (val) => {
        setData({
            ...data,
            apaterno: val
        });
    }
    const handleAmaternoChange = (val) => {
        setData({
            ...data,
            amaterno: val
        });
    }
    const handlePasswordChange = (val) => {
        setData({
            ...data,
            password: val
        });
    }
    const handleConfirmPasswordChange = (val) => {
        setData({
            ...data,
            confirm_password: val
        });
    }

    const registerHandle = (
        email, nombre, apaterno, amaterno, password, confirm_password,
    ) => {
        if (email.length === 0 || nombre.length === 0 || apaterno.length === 0 || amaterno.length === 0 || password.length === 0 || confirm_password.length === 0) {
            handleDialogOpen('Datos incompletos. Debe ingresar todos los datos del formulario.');
            return;
        }

        axios.post(GLOBAL.URL_LOGIN, {
            operacion: 'register',
            usuario: email,
            nombre: nombre,
            apaterno: apaterno,
            amaterno: amaterno,
            password: password,
            confirm_password: confirm_password,
        })
            .then(response => {
                if (response.status === 200) {
                    if (response.data.status === 'success') {
                        handleDialogOpen('Exito: ' + response.data.message);
                        setSuccess(true);
                    } else {
                        handleDialogOpen('Error: ' + response.data.message);
                    }
                } else {
                    handleDialogOpen('Error: No se ha podido registrar al usuario.');
                }
            })
            .catch(() => {
                handleDialogOpen('Error: Hubo un problema al conectarse con el servicio en línea.');
            });
    }

    if (success) {
        return <Redirect to={GLOBAL.ROOT_REF}/>;
    }

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline/>
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon/>
                </Avatar>
                <Typography component="h1" variant="h5">
                    Registrarse
                </Typography>
                <form className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                autoComplete="fname"
                                name="firstName"
                                variant="outlined"
                                required
                                fullWidth
                                id="firstName"
                                label="Nombre"
                                autoFocus
                                onChange={(val) => handleNombreChange(val.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="middleName"
                                label="Apellido Paterno"
                                name="middleName"
                                autoComplete="lname"
                                onChange={(val) => handleApaternoChange(val.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="lastName"
                                label="Apellido Materno"
                                name="lastName"
                                autoComplete="lname"
                                onChange={(val) => handleAmaternoChange(val.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                id="email"
                                label="Email"
                                name="email"
                                autoComplete="email"
                                onChange={(val) => handleEmailChange(val.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label="Contraseña"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                onChange={(val) => handlePasswordChange(val.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="confirmPassword"
                                label="Confirmar Contraseña"
                                type="password"
                                id="confirmPassword"
                                autoComplete="current-password"
                                onChange={(val) => handleConfirmPasswordChange(val.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Link onClick={handleOpen} variant="body2">
                                Ver Términos y Condiciones
                            </Link>
                            <Dialog
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                                fullWidth={true}
                                maxWidth={'md'}
                            >
                                <DialogTitle id="alert-dialog-title">{"Términos y Condiciones"}</DialogTitle>
                                <DialogContent>
                                    <Iframe url={GLOBAL.URL_APP + urlQuery}
                                            width="100%"
                                            height="500px"
                                            id="myId"
                                            className="myClassname"
                                            display="initial"
                                            position="relative"
                                            frameBorder="0"
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose} color="primary">
                                        Cerrar
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </Grid>
                        <Grid item xs={12}>
                            Al registrarse acepta los términos y condiciones de Culturas Andinas
                        </Grid>
                    </Grid>
                    <Button
                        type="button"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        onClick={() => {
                            registerHandle(
                                data.email, data.nombre,
                                data.apaterno, data.amaterno,
                                data.password, data.confirm_password)
                        }}
                    >
                        Registrarse
                    </Button>
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Link href={GLOBAL.ROOT_REF} variant="body2">
                                ¿Ya tiene una cuenta? Inicie sesión
                            </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
            <Dialog open={dialog.open} onClose={handleDialogClose}>
                <DialogContent>
                    <Grid container={true}>
                        <Grid item={true} xs={2} alignContent={'center'}>
                            <WarningIcon fontSize={"large"} color={'error'}/>
                        </Grid>
                        <Grid item={true} xs={10}>
                            <DialogContentText color={'error'}>
                                {dialog.text}
                            </DialogContentText>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>Cerrar</Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
}